var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.46913 8.4691H9.15376C12.9349 8.4691 16 11.5343 16 15.3154C16 15.6935 15.6935 16 15.3154 16H1.62286C1.24475 16 0.938232 15.6935 0.938232 15.3154C0.938232 11.5343 4.00341 8.4691 7.78449 8.4691H8.46913Z",
    fill: "#30C6C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.46914 8.4691C10.5487 8.4691 12.2346 6.78325 12.2346 4.70365C12.2346 2.62405 10.5487 0.938202 8.46914 0.938202C6.38954 0.938202 4.70369 2.62405 4.70369 4.70365C4.70369 6.78325 6.38954 8.4691 8.46914 8.4691Z",
    fill: "#30C6C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/Profile Icon.7660d7bc92f96a0384f0bb92ff1fb86f.svg";
export { ForwardRef as ReactComponent };